import { DomSanitizer } from '@angular/platform-browser';

import { Inject, Injectable, SecurityContext } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable()

export class CustomDomSanitizer extends DomSanitizer {
 isEvalSupported: boolean = false;
private sanitizer: DomSanitizer;

constructor(@Inject(DOCUMENT) sanitizer: DomSanitizer) {

super();

this.sanitizer = sanitizer;

}

sanitize(context: SecurityContext, value: any): string {

    if (context === SecurityContext.SCRIPT && !this.isEvalSupported) {
        throw new Error('eval() is disabled.');
      }

return this.sanitizer.sanitize(context, value);

}

// Override all bypass methods to prevent unsafe operations

bypassSecurityTrustHtml(value: string): any {

return this.sanitizer.bypassSecurityTrustHtml(value);

}

bypassSecurityTrustStyle(value: string): any {

return this.sanitizer.bypassSecurityTrustStyle(value);

}

bypassSecurityTrustScript(value: string): any {

throw new Error('bypassSecurityTrustScript is disabled.');

}

bypassSecurityTrustUrl(value: string): any {

return this.sanitizer.bypassSecurityTrustUrl(value);

}

bypassSecurityTrustResourceUrl(value: string): any {

return this.sanitizer.bypassSecurityTrustResourceUrl(value);

}

}